import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { UserLocaleUpdateOptions } from '../../../../../../../common/dist/angular/options/user-locale-update.options';
import { UserUpdateOptions } from '../../../../../../../common/dist/angular/options/user-update.options';
import { UserIdentityInterface } from '../../../../../../../common/dist/angular/interfaces/user-identity.interface';


@Injectable()
export class UserApiController {
  constructor(private readonly httpClient: HttpClient, @Inject('environment.api.url') private readonly apiUrl: string) {
  }

  public async getUserInfo(): Promise<UserIdentityInterface> {
    return this.httpClient.get<UserIdentityInterface>(`${this.apiUrl}/api/userInfo`).toPromise();
  }

  public async updateUser(userUpdateOptions: UserUpdateOptions): Promise<UserIdentityInterface> {
    return this.httpClient.put<UserIdentityInterface>(`${this.apiUrl}/api/users/current`, userUpdateOptions).toPromise();
  }

  public async updateLocale(userLocaleUpdateOptions: UserLocaleUpdateOptions): Promise<UserIdentityInterface> {
    return this.httpClient.put<UserIdentityInterface>(`${this.apiUrl}/api/users/current/locale`, userLocaleUpdateOptions).toPromise();
  }
}
